<template>
  <div v-if="documentsMetadata" class="d-flex flex-column i-p-6">
    <div class="fs-exclude i-mt-8">
      <notes />
    </div>
  </div>
  <div
    v-else
    class="d-flex align-items-center h-100 justify-content-center i-p-6"
  >
    <i-spinner></i-spinner>
  </div>
</template>

<script>
import { iIcon, iSpinner } from '@inscribe/signal';
import Notes from '@/V2/customers/Notes.vue';
export default {
  components: { iIcon, iSpinner, Notes },
  props: {
    selectedCustomer: {
      type: Object,
      default: null,
    },
  },
  computed: {
    documentsMetadata() {
      return this.$store.state.documentsMetadata;
    },
  },
};
</script>

<style lang="scss">
.customer-stats {
  font-size: $font-size-secondary;
  .icon-stat svg {
    width: 14px;
  }
}
</style>
